import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Title extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        current: PropTypes.number,
        handleTabsChange: PropTypes.func,
    };

    static defaultProps = {
        content: [],
        current: 0,
    };

    handleMouseOver = e => {
        const { content, handleTabsChange } = this.props;
        const index = Number(e.currentTarget.attributes['data-index'].value);

        if (content.length > 1) {
            handleTabsChange(index);
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, current } = this.props;

        return (
            <div className={styles.title_box}>
                {content.map((item, index) => (
                    <h4
                        key={index}
                        data-index={index}
                        className={`${styles.title} ${styles[`title${index}`]} ${
                            content.length === 1 || current === index ? styles.current : ''
                        }`}
                        onMouseEnter={this.handleMouseOver}>
                        <a href={item.url} target="_blank">
                            {item.title}
                        </a>
                    </h4>
                ))}
            </div>
        );
    }
}

export default Title;
